import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TLayoutDesktop, IDepsDesktop } from '../models';

import { Layout as Component } from './desktop';
import styles from './desktop.css';

export const LayoutDesktop = createWidget<IDepsDesktop, TLayoutDesktop>({ styles })(Component);
